import { render } from "./TableViewRow.vue?vue&type=template&id=2dde3f0e&scoped=true"
import script from "./TableViewRow.vue?vue&type=script&lang=js"
export * from "./TableViewRow.vue?vue&type=script&lang=js"

import "./TableViewRow.vue?vue&type=style&index=0&id=2dde3f0e&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dde3f0e"]])

export default __exports__